export default __webpack_public_path__ + "static/media/head-atp.2e6fabbd.jpg";